import { useSwrMutationApi } from 'src/hooks/useSwrApi';

interface UseSwrJobAudioInterviewProps {
  slug: string;
  locale: Locale;
}

export const useSwrJobAudioInterview = ({ slug, locale }: UseSwrJobAudioInterviewProps) => {
  return useSwrMutationApi<
    { message?: string },
    undefined
  >({
    url: `/v1/job-interview/${slug}/audio-interview`,
    locale,
    fetcherConfig: {
      method: 'POST',
    },
  });
};

